import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// English namespaces
import enCommon from "@/locales/en/common.json";
import enLocations from "@/locales/en/locations.json";
import enAssets from "@/locales/en/assets.json";
import enWorkOrders from "@/locales/en/work-orders.json";
import enPm from "@/locales/en/pm.json";
import enChecklists from "@/locales/en/checklists.json";
import enTemplates from "@/locales/en/templates.json";
import enInspections from "@/locales/en/inspections.json";
import enActions from "@/locales/en/actions.json";
import enInspectionSchedules from "@/locales/en/inspection-schedules.json";
import enReports from "@/locales/en/reports.json";
import enAnalytics from "@/locales/en/analytics.json";
import enDashboard from "@/locales/en/dashboard.json";
import enUsers from "@/locales/en/users.json";
import enSettings from "@/locales/en/settings.json";
import enLaborTracking from "@/locales/en/labor-tracking.json";
import enAuditLog from "@/locales/en/audit-log.json";
import enCustomFields from "@/locales/en/custom-fields.json";
import enInventory from "@/locales/en/inventory.json";
import enVendors from "@/locales/en/vendors.json";
import enNotifications from "@/locales/en/notifications.json";
import enIncidents from "@/locales/en/incidents.json";
import enMeterReadings from "@/locales/en/meter-readings.json";
import enEscalationRules from "@/locales/en/escalation-rules.json";
import enIntegrations from "@/locales/en/integrations.json";
import enAdmin from "@/locales/en/admin.json";
import enAdminPlans from "@/locales/en/admin-plans.json";
import enAdminTenants from "@/locales/en/admin-tenants.json";
import enAdminSettings from "@/locales/en/admin-settings.json";
import enTeams from "@/locales/en/teams.json";
import enAnalyticsWorkOrders from "@/locales/en/analytics-work-orders.json";
import enAnalyticsAssets from "@/locales/en/analytics-assets.json";
import enAnalyticsPreventive from "@/locales/en/analytics-preventive.json";
import enAnalyticsTeam from "@/locales/en/analytics-team.json";
import enAnalyticsSafety from "@/locales/en/analytics-safety.json";
import enSession from "@/locales/en/session.json";

// Spanish namespaces
import esCommon from "@/locales/es/common.json";
import esLocations from "@/locales/es/locations.json";
import esAssets from "@/locales/es/assets.json";
import esWorkOrders from "@/locales/es/work-orders.json";
import esPm from "@/locales/es/pm.json";
import esChecklists from "@/locales/es/checklists.json";
import esTemplates from "@/locales/es/templates.json";
import esInspections from "@/locales/es/inspections.json";
import esActions from "@/locales/es/actions.json";
import esInspectionSchedules from "@/locales/es/inspection-schedules.json";
import esReports from "@/locales/es/reports.json";
import esAnalytics from "@/locales/es/analytics.json";
import esDashboard from "@/locales/es/dashboard.json";
import esUsers from "@/locales/es/users.json";
import esSettings from "@/locales/es/settings.json";
import esLaborTracking from "@/locales/es/labor-tracking.json";
import esAuditLog from "@/locales/es/audit-log.json";
import esCustomFields from "@/locales/es/custom-fields.json";
import esInventory from "@/locales/es/inventory.json";
import esVendors from "@/locales/es/vendors.json";
import esNotifications from "@/locales/es/notifications.json";
import esIncidents from "@/locales/es/incidents.json";
import esMeterReadings from "@/locales/es/meter-readings.json";
import esEscalationRules from "@/locales/es/escalation-rules.json";
import esIntegrations from "@/locales/es/integrations.json";
import esAdmin from "@/locales/es/admin.json";
import esAdminPlans from "@/locales/es/admin-plans.json";
import esAdminTenants from "@/locales/es/admin-tenants.json";
import esAdminSettings from "@/locales/es/admin-settings.json";
import esTeams from "@/locales/es/teams.json";
import esAnalyticsWorkOrders from "@/locales/es/analytics-work-orders.json";
import esAnalyticsAssets from "@/locales/es/analytics-assets.json";
import esAnalyticsPreventive from "@/locales/es/analytics-preventive.json";
import esAnalyticsTeam from "@/locales/es/analytics-team.json";
import esAnalyticsSafety from "@/locales/es/analytics-safety.json";
import esSession from "@/locales/es/session.json";

const savedLang = typeof localStorage !== "undefined"
  ? (localStorage.getItem("i18n_language") ?? "en")
  : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      locations: enLocations,
      assets: enAssets,
      "work-orders": enWorkOrders,
      pm: enPm,
      checklists: enChecklists,
      templates: enTemplates,
      inspections: enInspections,
      actions: enActions,
      "inspection-schedules": enInspectionSchedules,
      reports: enReports,
      analytics: enAnalytics,
      dashboard: enDashboard,
      users: enUsers,
      settings: enSettings,
      "labor-tracking": enLaborTracking,
      "audit-log": enAuditLog,
      "custom-fields": enCustomFields,
      inventory: enInventory,
      vendors: enVendors,
      notifications: enNotifications,
      incidents: enIncidents,
      "meter-readings": enMeterReadings,
      "escalation-rules": enEscalationRules,
      integrations: enIntegrations,
      admin: enAdmin,
      "admin-plans": enAdminPlans,
      "admin-tenants": enAdminTenants,
      "admin-settings": enAdminSettings,
      teams: enTeams,
      "analytics-work-orders": enAnalyticsWorkOrders,
      "analytics-assets": enAnalyticsAssets,
      "analytics-preventive": enAnalyticsPreventive,
      "analytics-team": enAnalyticsTeam,
      "analytics-safety": enAnalyticsSafety,
      session: enSession,
    },
    es: {
      common: esCommon,
      locations: esLocations,
      assets: esAssets,
      "work-orders": esWorkOrders,
      pm: esPm,
      checklists: esChecklists,
      templates: esTemplates,
      inspections: esInspections,
      actions: esActions,
      "inspection-schedules": esInspectionSchedules,
      reports: esReports,
      analytics: esAnalytics,
      dashboard: esDashboard,
      users: esUsers,
      settings: esSettings,
      "labor-tracking": esLaborTracking,
      "audit-log": esAuditLog,
      "custom-fields": esCustomFields,
      inventory: esInventory,
      vendors: esVendors,
      notifications: esNotifications,
      incidents: esIncidents,
      "meter-readings": esMeterReadings,
      "escalation-rules": esEscalationRules,
      integrations: esIntegrations,
      admin: esAdmin,
      "admin-plans": esAdminPlans,
      "admin-tenants": esAdminTenants,
      "admin-settings": esAdminSettings,
      teams: esTeams,
      "analytics-work-orders": esAnalyticsWorkOrders,
      "analytics-assets": esAnalyticsAssets,
      "analytics-preventive": esAnalyticsPreventive,
      "analytics-team": esAnalyticsTeam,
      "analytics-safety": esAnalyticsSafety,
      session: esSession,
    },
  },
  lng: savedLang,
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export default i18n;
